import { useEffect, useRef } from "react";

/**
 * A hook that ensures an effect callback runs only once, even in React StrictMode.
 * Useful for side effects that should only happen once per component lifetime,
 * such as initializing libraries or starting services.
 */
function useEffectOnce(effect: () => void | (() => void)): void {
  const hasRun = useRef(false);
  const cleanup = useRef<void | (() => void)>(undefined);

  useEffect(() => {
    if (!hasRun.current) {
      hasRun.current = true;
      cleanup.current = effect();
    }

    return () => {
      if (cleanup.current) {
        cleanup.current();
      }
    };
  }, []);
}

export { useEffectOnce };
